import "../../../resources/less/Family/ThemePages/TrickOrTreat.less";
import BaseThematique from "./BaseThematique";

class TrickOrTreat extends BaseThematique {
  constructor() {
    super();
  }
}

$(window).on("load", () => {
  new TrickOrTreat();
});
